export const data = [
    {
        id: "0",
        question: "What is a West Coast (tank) drive?",
        answer: "A robot that has two rows of wheels on opposite sides and drives like a tank.",
        variants: [`A robot that has a mini tank below it.`, `A robot that has two rows of wheels on opposite sides and drives like a tank.`, `A type of drivetrain that is common on the US West Coast.`, `A type of drivetrain that is very niche and difficult to use.`]
    },
    {
        id: "1",
        question: "What is swerve drive?",
        answer: "",
        variants: [`A drivetrain that uses rows of wheels on opposite sides and drives like a tank.`, `A drivetrain that can resist swerving easily.`, `A drivetrain that uses 4 drive motors and 4 rotation motors, one on each corner of the robot.`, `A drivetrain that is unstable, so it swerves easily.`]
    },
    {
        id: "2",
        question: "What is a mecanum drive?",
        answer: "",
        variants: [`A drivetrain that uses aluminum-rim wheels.`, `A drivetrain that uses mecanum wheels.`, `A drivetrain that can easily push other robots.`, `A drivetrain that drives similarly to a tank drive.`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },